import { memo, useCallback, useContext } from 'react'
import NavBarButton from '../NavBarButton/NavBarButton'
import GeoContext from 'contexts/geoContext'
import CurrencyContext from 'contexts/currencyContext'
import Flag from 'LuxKit/Flag'
import ModalContext from 'contexts/ModalContext'
import config from 'constants/config'
import NavBarCurrencyLanguageModal from './NavBarCurrencyLanguageModal'
import { useVisibleLanguageOptions } from './useVisibleLanguageOptions'

interface Props {
  className?: string
}

function NavBarRegionButton(props: Props) {
  const currentCurrency = useContext(CurrencyContext)
  const { currentRegionCode } = useContext(GeoContext)
  const showModal = useContext(ModalContext)
  const { showLanguageSelector } = useVisibleLanguageOptions()

  const onClick = useCallback(() => {
    showModal(
      <NavBarCurrencyLanguageModal
        showLanguageTab={showLanguageSelector}
        tabletHeight="auto"
      />,
    )
  }, [showModal, showLanguageSelector])

  if (config.regions.length < 2) {
    return null
  }

  return (
    <NavBarButton
      className={props.className}
      icon={<Flag countryCode={currentRegionCode} size="S" />}
      onClick={onClick}
      contentBreakpointMin="desktop"
    >
      {currentCurrency.toUpperCase()}
    </NavBarButton>
  )
}

export default memo(NavBarRegionButton)
